import React, {useEffect} from 'react';
import Div from "@jumbo/shared/Div";
import * as yup from "yup";
import {Alert, Box, Button, FormControl, InputLabel, MenuItem, Typography} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
import {Form, Formik} from "formik";
import commonServices from "../../../../services/common-services";
import parentServices from "../../../../services/parent-services";
import {useTranslation} from "react-i18next";
import Select from "@mui/material/Select";
import {useSelector} from "react-redux";

const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];
const validationSchema = yup.object({
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string('Enter your password')
        .required('Password is required'),
});

const valuetext = (value) => {
    return value;
};


const Step4 = ({hideDialog, stepsData, handleNext, setStepsData}) => {

    const {authUser} = useSelector(state => state.auth);
    const [isLoading, setIsLoading] = React.useState(false);
    const [values, setValues] = React.useState({
        receivedHomeWork: '',
        autoTeacherReplacement: '',
        influencer: ''
    });
    const [errMsg, setErrMsg] = React.useState('');
    const {t} = useTranslation();

    const marks = [
        {
            value: 1,
            label: (t('parent-children.title.disagree')),
        },
        {
            value: 10,
            label: (t('parent-children.title.agree')),
        },
    ];


    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    useEffect(() => {

        console.log('authUser', authUser)

        if (stepsData) {
            setValues({...values, ...stepsData});
        }

    }, [stepsData])

    const submitStep = async () => {
        setErrMsg('');

        console.log(values);

        const {receivedHomeWork, autoTeacherReplacement, influencer} = values;


        try {
            setIsLoading(true);
            if (stepsData.newImage) {
                let b = await fetch(stepsData.newImage).then(r => r.blob());
                stepsData.imageBase64 = await commonServices.blobToBase64(b)
            }
            const v = {...stepsData, receivedHomeWork, autoTeacherReplacement, influencer}
            setStepsData(v);
            await parentServices.saveChild(v);

            console.log(v);



            const {firstName: parentFirstName, lastName: parentLastName, email: parentEmail, dateOfBirth : parentDateOfBirth} = authUser

            const {
                firstName, lastName, country, phone, currentClass, educationNeeds, email, dateOfBirth,
                hobbies, gender, projects, importantToKnowAbout, personality, residenceCountry
            } = v;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'ParentAddChild',
                currentClass,
                gender,
                educationNeeds,
                projects,
                importantToKnowAbout,
                influencer,
                personality,
                residenceCountry,
                email,
                hobbies,
                dateOfBirth,
                parentFirstName, country: country?.label, phone: phone?.fullNumber,
                parentLastName, parentEmail,
                firstName, lastName,
                parentDateOfBirth
            });

            handleNext(5);
        } catch (error) {
            console.log(error);
            setErrMsg(error.message);
            setIsLoading(false);
        }


    };


    return (
        <Box
            component="form"
            sx={{
                '& .MuiTextField-root': {m: 1},

            }}
            noValidate
            autoComplete="off"
        >
            <Formik
                validateOnChange={true}
                initialValues={values}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={() => {
                }}
            >
                {({isSubmitting}) => (
                    <Form noValidate autoComplete="off">


                        <Typography sx={{mt: 1, ml: 1}}
                                    variant={"h5"}>{t('childForm.content1')}</Typography>

                        <FormControl sx={{
                            width: {xs: '100%', sm: '100%', xl: '100%'},
                            mt: 1,
                            mb: 1,
                            ml: 1

                        }}>
                            <InputLabel id="demo-simple-select-label">{t('student-form.select')}</InputLabel>
                            <Select
                                sx={{width: '97%', minWidth: '50%'}}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values?.receivedHomeWork}
                                onChange={handleChange('receivedHomeWork')}
                                label={t('student-form.select')}


                            >
                                <MenuItem value='yes'>{t("common.yesBtn")}</MenuItem>
                                <MenuItem value='no'>{t("common.noBtn")}</MenuItem>
                            </Select>
                        </FormControl>


                        <Typography sx={{mt: 1, ml: 1}}
                                    variant={"h5"}>{t('childForm.content2')}</Typography>

                        <FormControl sx={{
                            width: {xs: '100%', sm: '100%', xl: '100%'},
                            mt: 1,
                            mb: 1,
                            ml: 1

                        }}>
                            <InputLabel id="demo-simple-select-label">{t('student-form.select')}</InputLabel>
                            <Select
                                sx={{width: '97%', minWidth: '50%'}}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values?.autoTeacherReplacement}
                                onChange={handleChange('autoTeacherReplacement')}
                                label={t('student-form.select')}


                            >
                                <MenuItem value='yes'>{t("common.yesBtn")}</MenuItem>
                                <MenuItem value='no'>{t("common.noBtn")}</MenuItem>
                            </Select>
                        </FormControl>


                        <Typography sx={{mt: 1, ml: 1}}
                                    variant={"h5"}>{t('childForm.content3')}</Typography>

                        <FormControl sx={{
                            width: {xs: '100%', sm: '100%', xl: '100%'},
                            mt: 1,
                            mb: 1,
                            ml: 1

                        }}>
                            <InputLabel id="demo-simple-select-label">{t('student-form.select')}</InputLabel>
                            <Select
                                required
                                sx={{width: '97%', minWidth: '50%'}}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values?.influencer}
                                onChange={handleChange('influencer')}
                                label={'common.select'}


                            >
                                <MenuItem value='yes'>{t("common.yesBtn")}</MenuItem>
                                <MenuItem value='no'>{t("common.noBtn")}</MenuItem>
                            </Select>
                        </FormControl>
                    </Form>
                )}</Formik>


            <Stack sx={{width: '100%'}} spacing={2}>
                {errMsg && <Alert severity="error">{errMsg}</Alert>}
            </Stack>
            <Div sx={{display: 'flex', flexDirection: 'row', pt: 2}}>

                <Button
                    onClick={() => {
                        handleNext(3)
                    }}
                    sx={{mr: 1}}
                >
                    {(t("common.backBtn"))}
                </Button>

                <Button
                    onClick={() => {
                        hideDialog();
                    }}
                    sx={{mr: 1}}
                >
                    {(t('common.cancelBtn'))}
                </Button>
                <Div sx={{flex: '1 1 auto'}}/>

                <LoadingButton loading={isLoading} variant={"variant"} onClick={submitStep}>
                    {(t('common.finishBtn'))}
                </LoadingButton>

            </Div>
        </Box>);

};

export default Step4;
